import React from "react";

export default class Streaks extends React.Component {
  render() {
    return <div>Streaks</div>;
  }
}
